module.exports = "/fonts/vendor/@fortawesome/fontawesome-free/webfa-solid-900.ttf?bacd5de623fb563b961a30e8349e44a9";